export let EditMode = /*#__PURE__*/function (EditMode) {
  EditMode["Enabled"] = "enabled";
  EditMode["Disabled"] = "disabled";
  return EditMode;
}({});
export let NotificationSettingsEntryType = /*#__PURE__*/function (NotificationSettingsEntryType) {
  NotificationSettingsEntryType["Single"] = "single";
  NotificationSettingsEntryType["Recurring"] = "recurring";
  return NotificationSettingsEntryType;
}({});
export class NotificationSettingsModel {
  static hasRecipients(_ref) {
    let {
      recipientTypes
    } = _ref;
    return !!recipientTypes.length;
  }
  constructor(data) {
    this.data = data;
  }
  isRecurring() {
    return this.data.type === NotificationSettingsEntryType.Recurring;
  }
  recurringMinutes() {
    if (!this.isRecurring()) return null;
    return this.data.recurring.minutes;
  }
  recurringTimes() {
    if (!this.isRecurring()) return null;
    return this.data.recurring.times;
  }
  makeSingleNotificationSettingsEntryUpdate(recipientTypes) {
    return {
      type: NotificationSettingsEntryType.Single,
      recipientTypes
    };
  }
  makeRecurringNotificationSettingsEntryUpdate(recipientTypes, recurring) {
    return {
      type: NotificationSettingsEntryType.Recurring,
      recipientTypes,
      recurring
    };
  }
}